var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as App from '../../../../app';
import { Animation } from '../../../../lib/classes/animation';
import { roundRect } from '../../../../lib/utils';
import { calcCellSize } from '../geometry';
var CellEffect = /** @class */ (function (_super) {
    __extends(CellEffect, _super);
    function CellEffect(props) {
        var _this = _super.call(this, props) || this;
        _this.delay = 0;
        _this.theme = App.themes.get().name;
        _this.size = calcCellSize();
        _this.r = CellEffect.getRadius(_this.size);
        _this.x = props.x || 0;
        _this.y = props.y || 0;
        _this.direction = _this.props.direction || -1;
        _this.delay = props.delay || 0;
        _this.speed = props.speed || 0.1;
        _this.color = props.color || App.themes.get().cell;
        return _this;
    }
    CellEffect.prototype.upd = function (dt) {
        _super.prototype.upd.call(this, dt);
        if (this.done)
            return;
    };
    CellEffect.prototype.draw = function (scene) {
        var delta = Math.max(0, this.time - this.delay) * this.speed;
        var wh = this.direction > 0 ? Math.min(this.size, delta) : Math.max(2, this.size - delta);
        if ((this.direction < 0 && wh < 5) || (this.direction > 0 && wh == this.size)) {
            if (!this.done) {
                this.done = true;
                this.props.onDone && this.props.onDone();
            }
            // return
        }
        var x = this.x + (this.size - wh) / 2;
        var y = this.y + (this.size - wh) / 2;
        if (this.theme === 'old-school') {
            scene.fillRect(x, y, wh - 1, wh - 1, this.color);
            var cellBorder = '#1e2941';
            scene.strokeRect(x, y, wh, wh, cellBorder, 2);
        }
        else {
            roundRect(scene, x, y, wh - 1, wh - 1, this.r, this.color);
        }
    };
    CellEffect.prototype.isDone = function () {
        return this.done;
    };
    CellEffect.getRadius = function (size) {
        return Math.ceil(size * (App.themes.get().name === 'default' ? 0.05 : 0.15));
    };
    return CellEffect;
}(Animation));
export { CellEffect };
